import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';
import { setCachedOpenDraft } from '@/features/dashboard/bookingChanges/hooks/useGetOpenDraft.ts';

/**
 * Anulowanie paczki w stanie nieostatecznym — backend zna jedno „anuluj" i dla
 * odrzucenia szkicu, i dla zdjęcia paczki od klienta. Komunikat o powodzeniu
 * należy więc do wołającego: to on wie, którą z tych dwóch rzeczy zrobił.
 */
const useCancelDraft = (bookingId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (changeId: string) =>
      bookingChangesApi.cancelDraft(bookingId, changeId),
    onSuccess: (change) => {
      // Świeży status idzie do pamięci podręcznej przed unieważnieniem, bo
      // podglądy paczki pytają cache o to, czy wciąż jest otwarta — a lista
      // paczek odświeży się dopiero za chwilę.
      setCachedOpenDraft(bookingId, change);
      queryClient.invalidateQueries({
        queryKey: bookingChangesApiQueryKeys.booking(bookingId),
      });
    },
    onError: (error: Error) => {
      toast.error('Nie udało się odrzucić szkicu', {
        description: error.message,
      });
    },
  });
};

export default useCancelDraft;
